import { Component, Input, OnInit } from '@angular/core';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';

@Component({
    standalone: false,
    selector: 'app-task-performance-details',
    templateUrl: './task-performance-details.component.html',
    styleUrls: ['./task-performance-details.component.scss']
})
export class TaskPerformanceDetailsComponent implements OnInit {
    @Input()
    task: ITaskModel;

    constructor() { }

    ngOnInit(): void {
    }

}
